import { Box, Button } from "@mui/material"
import DekuStickItem, { SimpleDekuStickItem }  from "../../inventory/items/DekuStickItem"
import DekuNutItem, { SimpleDekuNutItem } from "../../inventory/items/DekuNutsItem"
import BombItem from "../../inventory/items/BombItem"
import BowItem from "../../inventory/items/BowItem"
import FireArrowItem from "../../inventory/items/FireArrowItem"
import DinsFireItem from "../../inventory/items/DinsFireItem"
import SlingshotItem from "../../inventory/items/SlingshotItem"
import OcarinaItem, { SimpleOcarinaItem } from "../../inventory/items/OcarinaItem"
import BombchusItem from "../../inventory/items/BombchusItem"
import HookshotItem from "../../inventory/items/HookshotItem"
import IceArrowItem from "../../inventory/items/IceArrowItem"
import  { SimpleFaroresWindItem } from "../../inventory/items/FaroresWindItem"
import BoomrangItem from "../../inventory/items/BoomrangItem"
import  { SimpleLensOfTruthItem } from "../../inventory/items/LensOfTruthItem"
import MagicBeansItem from "../../inventory/items/MagicBeansItem"
import MegatonHammerItem from "../../inventory/items/MegatonHammerItem"
import LightArrowItem from "../../inventory/items/LightArrowItem"
import NayrusLoveItem from "../../inventory/items/NayrusLoveItem"
import { CommonBigPoeBottleItem } from "../../inventory/items/BigPoeBottleItem"
import { CommonEmptyBottleItem } from "../../inventory/items/EmptyBottle"
import MagicItem from "../../inventory/items/MagicItem"
import WalletItem from "../../inventory/items/WalletItem"
import ScaleItem from "../../inventory/items/ScaleItem"
import StrengthItem from "../../inventory/items/StrengthItem"
import KokiriSwordItem from "../../inventory/items/KokiriSwordItem"
import HylianShieldItem from "../../inventory/items/HylianShieldItem"
import GoronTunicItem from "../../inventory/items/GoronTunicItem"
import IronBootsItem from "../../inventory/items/IronBootsItem"
import TokenItemCounter from "../../inventory/items/TokenCounterItem"
import BiggoronSwordItem from "../../inventory/items/BiggoronSwordItem"
import MirrorShieldItem from "../../inventory/items/MirrorShieldItem"
import ZoraTunicItem from "../../inventory/items/ZoraTunicItem"
import HoverBootsItem from "../../inventory/items/HoverBootsItem"
import ZeldaLullabySong from "../../inventory/songs/ZeldaLullabySong"
import EponaSong from "../../inventory/songs/EponaSong"
import SariaSong from "../../inventory/songs/SariaSong"
import SunSong from "../../inventory/songs/SunSong"
import TimeSong from "../../inventory/songs/TimeSong"
import StormSong from "../../inventory/songs/StormSong"
import MinuetOfForest from "../../inventory/songs/MinuetOfForest"
import BoleroOfFire from "../../inventory/songs/BoleroOfFire"
import SerenadeOfWater from "../../inventory/songs/SerenadeOfWater"
import NocturneOfShadow from "../../inventory/songs/NocturneOfShadow"
import RequiemOfSpirit from "../../inventory/songs/RequiemOfSpirit"
import PreludeOfLight from "../../inventory/songs/PreludeOfLight"
import LightMedallionItem from "../../inventory/medallions/LightMedallionItem"
import ForestMedallionItem from "../../inventory/medallions/ForestMedallionItem"
import FireMedallionItem from "../../inventory/medallions/FireMedallionItem"
import WaterMedallionItem from "../../inventory/medallions/WaterMedallionItem"
import ShadowMedallionItem from "../../inventory/medallions/ShadowMedallionItem"
import SpiritMedallionItem from "../../inventory/medallions/SpiritMedallionItem"
import KokiriEmeraldItem from "../../inventory/medallions/KokiriEmeraldItem"
import GoronRubyItem from "../../inventory/medallions/GoronRubyItem"
import ZoraSapphireItem from "../../inventory/medallions/ZoraSapphireItem"
import DefaultAlwaysHint from "../../hints/AlwaysHints"
import Token10 from "../../../core/assets/oot/gshd/10-collected-skulltulas_32x32.png";
import Token20 from "../../../core/assets/oot/gshd/20-collected-skulltulas_32x32.png";
import Token30 from "../../../core/assets/oot/gshd/30-gold-skulltula_32x32.png";
import Token40 from "../../../core/assets/oot/gshd/40-gold-skulltula_32x32.png";
import Token50 from "../../../core/assets/oot/gshd/50-gold-skulltula_32x32.png";
import GoronMask from "../../../core/assets/oot/gshd/biggoron_32x32.png";
import Frog from "../../../core/assets/oot/gshd/frogs_32x32.png";
import Cow from "../../../core/assets/oot/classic/cow.png";
import OoT from "../../../core/assets/oot/gshd/ocarina-of-time_32x32.png";
import Nocturne from "../../../core/assets/oot/gshd/nocturne_32x32.png";
import Scrub from "../../../core/assets/oot/classic/business_scrub.png";
import BossSelector from "../../ennemy/BossSelector"
import DungeonSelector, { dungeons } from "../../dungeon/DungeonSelector"
import { DungeonKeysTrackingHorizontal } from "../../keysanity/DungeonsKeysTracking"
import { DungeonsKeysList } from "../../keysanity/DungeonsKeysData"
import { isEmpty } from "lodash"
import TrialTracker from "../../trials/TrialTracker"
import ChildSequenceItem from "../../inventory/items/ChildSequenceItem"
import GerudoCardItem from "../../inventory/items/GerudoCardItem"
import RutoLetterItem from "../../inventory/items/RutoLetterBottle"
import OotItemContextMenuButton from "../../hints/OotItemContextMenuButton"
import { useState } from "react"
import ModalSettings from "./ModalSettings"
import { useSelector } from "react-redux"
import { AppState } from "../../../core/app/AppReducer"
import { BarrenHint } from "../../mixpool/ReworkwothHint"
import SometimeHint from "../../hints/SometimesHint"
import ShopsanityTracker from "../../shopsanity/ShopSanityTracker"
import { SoulTracker } from "../../ennemy/EnnemyTracker"
import PathHint from "../../hints/PathHint"
import LightSphereTracker from "../../sphere/LigthSphereTracker"
import AdultSequenceItem from "../../inventory/items/AdultSequenceItem"
import { resetState } from "./TournoiFrancoReducer"
import { useDispatch } from "react-redux"

const TournoiFrancoTracker = () => {

  let state = useSelector((state: AppState) => state.ui.ootr.tournoiFranco);
  let [open, setOpen] = useState<boolean>(false)
  let nbSometimes = 7;
  let dispatch = useDispatch();

  if(state.scrubSanity)
    nbSometimes -=1;
  if(state.cowSanity)
    nbSometimes -= 1

    return <Box>
      <ModalSettings isOpen={open} setOpen={setOpen} />
      <Box position={"absolute"} top={70} left={80}>
        <Button onClick={() => {setOpen(!open)}}>Settings</Button>
        <Button onClick={() => {dispatch(resetState())}}>Reset State</Button>
      </Box>

    <Box position={"absolute"} top={100} left={80}>
        {state.noZl ? <DekuStickItem  /> : <SimpleDekuStickItem />}
      </Box>
      <Box position={"absolute"} top={100} left={112}>
      {state.noZl ? <DekuNutItem /> : <SimpleDekuNutItem />}
      </Box>
      <Box position={"absolute"} top={100} left={144}>
        <BombItem />
      </Box>
      <Box position={"absolute"} top={100} left={176}>
        <BowItem />
      </Box>
      <Box position={"absolute"} top={100} left={208}>
        <FireArrowItem />
      </Box>
      <Box position={"absolute"} top={100} left={240}>
        <DinsFireItem />
      </Box>

      {/* Line 2 */}
      <Box position={"absolute"} top={132} left={80}>
        <SlingshotItem />
      </Box>
      <Box position={"absolute"} top={132} left={112}>
        {state.ocarinaShuffle ? <OcarinaItem /> : <SimpleOcarinaItem/>}
      </Box>
      <Box position={"absolute"} top={132} left={144}>
        <BombchusItem />
      </Box>
      <Box position={"absolute"} top={132} left={176}>
        <HookshotItem />
      </Box>
      <Box position={"absolute"} top={132} left={208}>
        <IceArrowItem />
      </Box>
      <Box position={"absolute"} top={132} left={240}>
        <SimpleFaroresWindItem />
      </Box>

      {/* Line 3 */}
      <Box position={"absolute"} top={164} left={80}>
        <BoomrangItem />
      </Box>
      <Box position={"absolute"} top={164} left={112}>
        <SimpleLensOfTruthItem />
      </Box>
      <Box position={"absolute"} top={164} left={144}>
        <MagicBeansItem  />
      </Box>
      <Box position={"absolute"} top={164} left={176}>
        <MegatonHammerItem />
      </Box>
      <Box position={"absolute"} top={164} left={208}>
        <LightArrowItem />
      </Box>
      <Box position={"absolute"} top={164} left={240}>
        <NayrusLoveItem />
      </Box>

      {/* Line 4 */}
      <Box position={"absolute"} top={198} left={80}>
        <CommonBigPoeBottleItem />
      </Box>
      <Box position={"absolute"} top={198} left={112}>
        <CommonEmptyBottleItem />
      </Box>
      <Box position={"absolute"} top={198} left={144}>
        <MagicItem />
      </Box>
      <Box position={"absolute"} top={198} left={176}>
        <WalletItem />
      </Box>
      <Box position={"absolute"} top={198} left={208}>
        <ScaleItem />
      </Box>
      <Box position={"absolute"} top={198} left={240}>
        <StrengthItem />
      </Box>

      {/* Equipements */}
      {/* Line 1 */}
      <Box position={"absolute"} top={230} left={80}>
        <KokiriSwordItem />
      </Box>
      <Box position={"absolute"} top={230} left={112}>
        <HylianShieldItem />
      </Box>
      <Box position={"absolute"} top={230} left={144}>
        <GoronTunicItem />
      </Box>
      <Box position={"absolute"} top={230} left={176}>
        <IronBootsItem />
      </Box>
      <Box position={"absolute"} top={240} left={225}>
        <TokenItemCounter />
      </Box>

      {/* Line 2 */}
      <Box position={"absolute"} top={262} left={80}>
        <BiggoronSwordItem />
      </Box>
      <Box position={"absolute"} top={262} left={112}>
        <MirrorShieldItem />
      </Box>
      <Box position={"absolute"} top={262} left={144}>
        <ZoraTunicItem />
      </Box>
      <Box position={"absolute"} top={262} left={176}>
        <HoverBootsItem />
      </Box>

      {/* Songs */}
      {/* Line 1 */}
      <Box position={"absolute"} top={300} left={80}>
        <ZeldaLullabySong cleft cright cup display="horizontal" />
      </Box>
      <Box position={"absolute"} top={300} left={112}>
        <EponaSong cleft cright cup display="horizontal" />
      </Box>
      <Box position={"absolute"} top={300} left={144}>
        <SariaSong cleft cright cdown display="horizontal" />
      </Box>
      <Box position={"absolute"} top={300} left={176}>
        <SunSong cdown cright cup display="horizontal" />
      </Box>
      <Box position={"absolute"} top={300} left={208}>
        <TimeSong a cdown cright display="horizontal" />
      </Box>
      <Box position={"absolute"} top={300} left={240}>
        <StormSong a cdown cup display="horizontal" />
      </Box>

      {/* Line 2 */}
      <Box position={"absolute"} top={345} left={80}>
        <MinuetOfForest a cleft cright cup display="horizontal" />
      </Box>
      <Box position={"absolute"} top={345} left={112}>
        <BoleroOfFire a cright cdown display="horizontal" />
      </Box>
      <Box position={"absolute"} top={345} left={144}>
        <SerenadeOfWater a cleft cright cdown display="horizontal" />
      </Box>
      <Box position={"absolute"} top={345} left={176}>
        <NocturneOfShadow cdown cright cleft a display="horizontal" />
      </Box>
      <Box position={"absolute"} top={345} left={208}>
        <RequiemOfSpirit a cdown cright display="horizontal" />
      </Box>
      <Box position={"absolute"} top={345} left={240}>
        <PreludeOfLight cleft cright cup display="horizontal" />
      </Box>

      {/* Medallion and Stone */}
      <Box position={"absolute"} top={100} left={272}>
        <LightMedallionItem />
      </Box>
      <Box position={"absolute"} top={100} left={315}>
        <ForestMedallionItem />
      </Box>
      <Box position={"absolute"} top={100} left={360}>
        <FireMedallionItem />
      </Box>
      <Box position={"absolute"} top={150} left={272}>
        <WaterMedallionItem />
      </Box>
      <Box position={"absolute"} top={150} left={315}>
        <ShadowMedallionItem />
      </Box>
      <Box position={"absolute"} top={150} left={360}>
        <SpiritMedallionItem />
      </Box>
      <Box position={"absolute"} top={200} left={272}>
        <KokiriEmeraldItem />
      </Box>
      <Box position={"absolute"} top={200} left={315}>
        <GoronRubyItem />
      </Box>
      <Box position={"absolute"} top={200} left={360}>
        <ZoraSapphireItem />
      </Box>

      {/* Always */}
      <Box position={"absolute"} top={250} left={272}>
        <DefaultAlwaysHint hint={{ name: "ZR Frogs Ocarina Game", img: Frog }} />
      </Box>
      <Box position={"absolute"} top={250} left={340}>
        <DefaultAlwaysHint hint={{ name: "DMT Biggoron", img: GoronMask }} />
      </Box>
      <Box position={"absolute"} top={282} left={272}>
      <DefaultAlwaysHint
          hint={{ name: "Kak 10 Gold Skulltula Reward", img: Token10 }}
        />
      </Box>
      <Box position={"absolute"} top={282} left={340}>
        <DefaultAlwaysHint
          hint={{ name: "Kak 20 Gold Skulltula Reward", img: Token20 }}
        />
      </Box>
      <Box position={"absolute"} top={314} left={272}>
      <DefaultAlwaysHint
          hint={{ name: "Kak 30 Gold Skulltula Reward", img: Token30 }}
        />
      </Box>
      <Box position={"absolute"} top={314} left={340}>
      <DefaultAlwaysHint
          hint={{ name: "Kak 40 Gold Skulltula Reward", img: Token40 }}
        />
      </Box>
      <Box position={"absolute"} top={346} left={272}>
      <DefaultAlwaysHint
          hint={{ name: "Kak 50 Gold Skulltula Reward", img: Token50 }}
        />
      </Box>

      <Box position={"absolute"} top={378} left={272}>
        <DefaultAlwaysHint
          hint={{ name: "OoT Song", img: OoT }}
        />
      </Box>
      <Box position={"absolute"} top={378} left={340}>
        <DefaultAlwaysHint
          hint={{ name: "Burning Kak", img: Nocturne }}
        />
      </Box>
      {state.cowSanity && <Box position={"absolute"} top={410} left={272}>
        <DefaultAlwaysHint
          hint={{ name: "Cow Link", img: Cow }}
        />
      </Box>}
      {state.scrubSanity && <Box position={"absolute"} top={410} left={340}>
        <DefaultAlwaysHint
          hint={{ name: "Scrub", img: Scrub }}
        />
      </Box>}
      <Box display={"flex"} position={"absolute"} top={100} left={410} flexDirection={"column"}>
        {Array.from(Array(nbSometimes).keys()).map(t => {
            return <SometimeHint />
        })}
      </Box>


      {/* DUNGEONS */}
      <Box display={"flex"} position={"absolute"} top={100} left={630} flexDirection={"column"} width={400}>
        <Box  display={"flex"} flexDirection={"row"}>
          <Box width={50} textAlign={"center"}>Donjon</Box>
          {state.erDungeon && <Box width={50} textAlign={"center"}>Loc</Box>}
          {state.bossShuffle &&  <Box width={50} textAlign={"center"}>Boss</Box>}
          {state.oneMajorItem &&<Box width={40} textAlign={"center"}>Major</Box>}
          {state.songDungeonReward &&<Box width={40} textAlign={"center"}>Song</Box>}
          <Box width={100}></Box>
        </Box>
        {dungeons.map(d => {
            if(isEmpty(d) || DungeonsKeysList.filter(x => x.dungeon === d).length === 0)
                return null;
            return <Box display={"flex"} flexDirection={"row"}>
                  <Box width={50} display="flex" alignItems={"center"}>{d}</Box>
                  {state.erDungeon &&  <Box width={50} display={"flex"} justifyContent={"center"}><DungeonSelector /></Box> }
                  {state.bossShuffle &&  <Box width={50} marginRight={1} display={"flex"} justifyContent={"center"}><BossSelector /></Box>} 
                  {state.oneMajorItem && <Box width={35} display={"flex"} justifyContent={"center"}><OotItemContextMenuButton /></Box> }
                  {state.songDungeonReward && <Box width={35} display={"flex"} justifyContent={"center"}><OotItemContextMenuButton /></Box> }
                  <Box width={100}><DungeonKeysTrackingHorizontal keysy={state.keysy} keyring={state.keyring}  dungeon={DungeonsKeysList.filter(x => x.dungeon === d)?.[0]} id={d} />   </Box>
                </Box>
        })}
      </Box>
      <Box  display={"flex"} position={"absolute"} top={700} left={610}>
        <SoulTracker displayLabel={false} track={state.allSoulSanity ? "all" : state.regionalSoulSanity ? "regional" : state.bossSoulSanity ? "boss" : undefined}/>
      </Box>
      <Box  display={"flex"} position={"absolute"} top={100} left={1010} flexDirection={"column"} >
        <LightSphereTracker />
      </Box>



      <Box display={"flex"} position={"absolute"} top={390} left={420} flexDirection={"row"} flexWrap={"wrap"} width={120}>
        <Box display={"flex"} alignItems={"center"}>Additional Settings</Box>
        <AdultSequenceItem />
        {state.noZl && <ChildSequenceItem />}
        {state.shuffleGerudoCard && <GerudoCardItem />}
        {state.openDeku && <KokiriSwordItem />}
        {!state.openFountain && <RutoLetterItem />}
         {state.bombchuBag && <BombchusItem />} 
      </Box>
    
      <Box
        position={"absolute"}
        top={450}
        left={80}
        display={"flex"}
        alignItems={"center"}
      >
        {" "}
          <PathHint id={1} />
        </Box>
      <Box
        position={"absolute"}
        top={485}
        left={80}
        display={"flex"}
        alignItems={"center"}
      >
        {" "}
        <PathHint id={2} />
      </Box>
      <Box
        position={"absolute"}
        top={520}
        left={80}
        display={"flex"}
        alignItems={"center"}
      >
        {" "}
        <PathHint id={3} />
      </Box>
      <Box
        position={"absolute"}
        top={555}
        left={80}
        display={"flex"}
        alignItems={"center"}
      >
        {" "}
        <PathHint id={4} />
      </Box>
      <Box
        position={"absolute"}
        top={590}
        left={80}
        display={"flex"}
        alignItems={"center"}
      >
        {" "}
        <PathHint id={5} />
      </Box>
      {/* 3 Barrens  */}
      <Box
        position={"absolute"}
        top={625}
        left={80}
        display={"flex"}
        alignItems={"center"}
      >
        {" "}
        <BarrenHint />
      </Box>
      <Box
        position={"absolute"}
        top={660}
        left={80}
        display={"flex"}
        alignItems={"center"}
      >
        {" "}
        <BarrenHint />
      </Box>
      <Box
        position={"absolute"}
        top={695}
        left={80}
        display={"flex"}
        alignItems={"center"}
      >
        {" "}
        <BarrenHint />
      </Box>
      <Box display={"flex"} position={"absolute"} top={380} left={100} flexDirection={"column"}  >
        {state.trials && <TrialTracker useRedux={false}/>}
      </Box>
      {state.shopSanity && <Box
        position={"absolute"}
        top={740

        }
        left={100}
        display={"flex"}
        justifyContent={"flex-start"}
        flexDirection={"column"}
        flexWrap={"wrap"}
      >
        <ShopsanityTracker />
  </Box>}

    </Box>
}

export default TournoiFrancoTracker